import React from 'react';
import { Flex } from '@chakra-ui/react';
import { BannerImage } from './images/BannerImage';
import { BannerHeaderImage } from './images/BannerHeaderImage';

export const Banner = React.memo(() => {
  return (
    <Flex mt={4} justifyContent="center" position="relative">
      <BannerImage />
      <BannerHeaderImage />
    </Flex>
  );
});
